import React from 'react';

import QuotaSupervisor  from 'components/Tvendo/Sale/QuotaBPartner/Clorox/QuotaSupervisorClorox/List.js';

export default function () {
  return <QuotaSupervisor  />;
}